<div class="fix-action-row" data-qa="import-dialog">
  <div mat-dialog-content>

    <mat-horizontal-stepper
      linear="true"
      data-qa="stepper"
      #stepper>
      <mat-step [attr.data-qa]="'step-1'">
        <form>
          <ng-template matStepLabel>Excel Datei auswählen</ng-template>

          <div style="padding-bottom: 20px;">
            <p>
              Hier sind Sie richtig, um Erzeugungsanlagen anhand eines Excel-Dokuments zu importieren. Da
              das Excel-Dokument gewissen Formalien entsprechen muss, empfehlen wir,
              vorher über das TNB-Portal ihre Erzeugungsanlagen zu exportieren. Sie erhalten dann ein
              Excel-Dokument zum Download, in dem Sie bestehende Erzeuger modifizieren, löschen und
              hinzufügen können. Eine ausführliche Dokumentation zum Import finden Sie hier.
            </p>
          </div>

          <redispatch-upload-file-form
            (fileEventEmitter)="handleFileChange($event)"
            allowedFileMimeType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            allowedFileTypeName="Excel">
          </redispatch-upload-file-form>

        </form>

      </mat-step>

      <mat-step>
        <form>
          <ng-template matStepLabel>Ergebnis überprüfen</ng-template>

          @if (!importReport && job) {
            <div>
              @if (!backendFailure) {
                <div>
                  <mat-progress-bar
                    class="progress-bar"
                    [color]="'primary'"
                    [mode]="'determinate'"
                    [value]="(job.nrProcessedTransformations / job.erzeugerTotal) * 100">
                  </mat-progress-bar>
                  <table class="phase-table">
                    <tr>
                      <td>
                        @if (job.phase <= ErzeugungsanlageImportJobPhase.PHASE_INITIAL) {
                          <mat-icon class="spinner"
                            >
                            check_box_outline_blank
                          </mat-icon>
                        }
                        @if (job.phase > ErzeugungsanlageImportJobPhase.PHASE_INITIAL) {
                          <mat-icon class="progress-done"
                            >
                            check_box
                          </mat-icon>
                        }
                      </td>
                      <td>
                        <span
                          [class.bold]="job.phase === ErzeugungsanlageImportJobPhase.PHASE_INITIAL">
                          Laden und Prüfen des Excel-Dokuments
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        @if (job.phase <= ErzeugungsanlageImportJobPhase.PHASE_VALIDATE) {
                          <mat-icon class="spinner"
                            >
                            check_box_outline_blank
                          </mat-icon>
                        }
                        @if (job.phase > ErzeugungsanlageImportJobPhase.PHASE_VALIDATE) {
                          <mat-icon class="progress-done"
                            >
                            check_box
                          </mat-icon>
                        }
                      </td>
                      <td>
                        <span
                          [class.bold]="job.phase === ErzeugungsanlageImportJobPhase.PHASE_VALIDATE">
                          Analysieren und Validieren von {{ job.nrProcessedTransformations }}
                          / {{ job.erzeugerTotal }} Erzeugungsanlagen
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        @if (job.phase <= ErzeugungsanlageImportJobPhase.PHASE_CHECK_CONSTRAINT) {
                          <mat-icon class="spinner"
                            >
                            check_box_outline_blank
                          </mat-icon>
                        }
                        @if (job.phase > ErzeugungsanlageImportJobPhase.PHASE_CHECK_CONSTRAINT) {
                          <mat-icon class="progress-done"
                            >
                            check_box
                          </mat-icon>
                        }
                      </td>
                      <td>
                        <span
                          [class.bold]="job.phase === ErzeugungsanlageImportJobPhase.PHASE_CHECK_CONSTRAINT">
                          Prüfe auf ungültige Dokumenten- und Ressourcen-IDs
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        @if (job.phase <= ErzeugungsanlageImportJobPhase.PHASE_CHECK_PLANWERTE) {
                          <mat-icon class="spinner"
                            >
                            check_box_outline_blank
                          </mat-icon>
                        }
                        @if (job.phase > ErzeugungsanlageImportJobPhase.PHASE_CHECK_PLANWERTE) {
                          <mat-icon class="progress-done"
                            >
                            check_box
                          </mat-icon>
                        }
                      </td>
                      <td>
                        <span
                          [class.bold]="job.phase === ErzeugungsanlageImportJobPhase.PHASE_CHECK_PLANWERTE">
                          Prüfe auf Planwerte die ungültig werden
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        @if (job.phase <= ErzeugungsanlageImportJobPhase.PHASE_PERSIST) {
                          <mat-icon class="spinner"
                            >
                            check_box_outline_blank
                          </mat-icon>
                        }
                        @if (job.phase > ErzeugungsanlageImportJobPhase.PHASE_PERSIST) {
                          <mat-icon class="progress-done">check_box</mat-icon>
                        }
                      </td>
                      <td>
                        <span
                          [class.bold]="job.phase > ErzeugungsanlageImportJobPhase.PHASE_CHECK_PLANWERTE">
                          Bereite Prüfbericht vor
                        </span>
                      </td>
                    </tr>
                  </table>
                </div>
              }
              @if (backendFailure) {
                <div class="backend-failure">
                  <img class="backend-failure-image"
                    src="/assets/westnetz-icons/smileys/picto_smiley_sad.svg">
                  </div>
                  Es ist leider ein Fehler bei der Kommunikation mit dem Server aufgetreten und die
                  Erzeugungsanlagen konnten nicht geprüft werden. Wir empfehlen, den Importvorgang noch
                  einmal
                  neu zu beginnen.
                }
              </div>
            }
            @if (importReport) {
              <redispatch-importreport-display [erzeugungsanlagenImportReport]="importReport"
              [id]="PRINT_ELEMENT_ID"></redispatch-importreport-display>
            }

          </form>
        </mat-step>

        <mat-step>
          <ng-template matStepLabel>Fertig</ng-template>
          @if (!importReport && job) {
            @if (!backendFailure) {
              <mat-progress-bar
                class="progress-bar"
                [color]="'primary'"
                [mode]="'determinate'"
                [value]="((job.nrProcessedTransformations  + job.nrStoredErzeuger) / (job.erzeugerTotal * 2)) * 100">
              </mat-progress-bar>
              <table class="phase-table">
                <tr>
                  <td>
                    @if (job.phase <= ErzeugungsanlageImportJobPhase.PHASE_INITIAL) {
                      <mat-icon class="spinner"
                        >
                      check_box_outline_blank
                    </mat-icon>
                  }
                  @if (job.phase > ErzeugungsanlageImportJobPhase.PHASE_INITIAL) {
                    <mat-icon class="progress-done"
                      >
                      check_box
                    </mat-icon>
                  }
                </td>
                <td>
                  <span
                    [class.bold]="job.phase === ErzeugungsanlageImportJobPhase.PHASE_INITIAL">
                    Laden und Prüfen des Excel-Dokuments
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  @if (job.phase <= ErzeugungsanlageImportJobPhase.PHASE_VALIDATE) {
                    <mat-icon class="spinner"
                      >
                      check_box_outline_blank
                    </mat-icon>
                  }
                  @if (job.phase > ErzeugungsanlageImportJobPhase.PHASE_VALIDATE) {
                    <mat-icon class="progress-done"
                      >
                      check_box
                    </mat-icon>
                  }
                </td>
                <td>
                  <span
                    [class.bold]="job.phase === ErzeugungsanlageImportJobPhase.PHASE_VALIDATE">
                    Analysieren und Validieren von {{ job.nrProcessedTransformations }}
                    / {{ job.erzeugerTotal }} Erzeugungsanlagen
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  @if (job.phase <= ErzeugungsanlageImportJobPhase.PHASE_CHECK_CONSTRAINT) {
                    <mat-icon class="spinner"
                      >
                      check_box_outline_blank
                    </mat-icon>
                  }
                  @if (job.phase > ErzeugungsanlageImportJobPhase.PHASE_CHECK_CONSTRAINT) {
                    <mat-icon class="progress-done"
                      >
                      check_box
                    </mat-icon>
                  }
                </td>
                <td>
                  <span
                    [class.bold]="job.phase === ErzeugungsanlageImportJobPhase.PHASE_CHECK_CONSTRAINT">
                    Prüfe auf ungültige Dokumenten- und Ressourcen-IDs
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  @if (job.phase <= ErzeugungsanlageImportJobPhase.PHASE_PERSIST) {
                    <mat-icon class="spinner"
                      >
                      check_box_outline_blank
                    </mat-icon>
                  }
                  @if (job.phase > ErzeugungsanlageImportJobPhase.PHASE_PERSIST) {
                    <mat-icon class="progress-done"
                      >
                      check_box
                    </mat-icon>
                  }
                </td>
                <td>
                  <span
                    [class.bold]="job.phase === ErzeugungsanlageImportJobPhase.PHASE_PERSIST">
                    Speichern von {{ job.nrStoredErzeuger }} / {{ job.erzeugerTotal }}
                    Erzeugungsanlagen in der Datenbank
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  @if (job.phase < ErzeugungsanlageImportJobPhase.PHASE_FINALIZE) {
                    <mat-icon class="spinner"
                      >
                      check_box_outline_blank
                    </mat-icon>
                  }
                  @if (job.done) {
                    <mat-icon class="progress-done">check_box</mat-icon>
                  }
                </td>
                <td>
                  <span
                    [class.bold]="job.phase === ErzeugungsanlageImportJobPhase.PHASE_FINALIZE">
                    Importvorgang abschließen
                  </span>
                </td>
              </tr>
            </table>
          }
          @if (backendFailure) {
            <div class="backend-failure">
              <img class="backend-failure-image"
                src="/assets/westnetz-icons/smileys/picto_smiley_sad.svg">
              </div>
              Es ist leider ein Fehler bei der Kommunikation mit dem Server aufgetreten und die
              Erzeugungsanlagen wurden möglicherweise nicht importiert. Wir empfehlen, den Importvorgang
              noch einmal
              neu zu beginnen.
            }
          }

          @if (importReport && job) {
            @if (importReport.success) {
              <div>
                <h2>Die Anlagen wurden erfolgreich importiert</h2>
              </div>
            }
            @if (!importReport.success) {
              <div>
                <h2>Es ist leider ein Fehler beim Import aufgetreten. Sollte der Import bei einem erneuten
                  Versuch
                  wiederholt scheitern, schicken Sie das Excel-Dokument zur Prüfung bitte an Ihren
                Kundenbetreuer.</h2>
              </div>
            }
          }
        </mat-step>
      </mat-horizontal-stepper>
    </div>

    <div class="spacer"></div>

    <div mat-dialog-actions class="wizard-footer">
      @if (loading) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }

      <div class="wizard-footer-right">
        @if (stepper.selectedIndex === 1 && containsLogs()) {
          <button
            matButton="outlined"
            aria-label="Öffnet den Druckdialog um z.B. den Druckbereich als PDF zu speichern"
            matTooltip="Öffnet den Druckdialog um z.B. den Druckbereich als PDF zu speichern"
            matTooltipPosition="left"
            color="primary"
            data-qa="print-button"
            (click)="print()">
          Fehlermeldungen drucken
        </button>
      }

      @if (stepper.selectedIndex !== 2) {
        <button
          matButton="outlined"
          data-qa="cancel-button"
          (click)="close()">
            <mat-icon svgIcon="innogy_picto_close"></mat-icon>
          Abbrechen
        </button>
      }

      @if (stepper.selectedIndex === 0 && !!selectedFile) {
        <button
          class="confirm-button"
          matButton="filled"
          data-qa="upload-and-check-button"
          (click)="upload(true)">
            <mat-icon>cloud_upload</mat-icon>
          Datei hochladen und prüfen
        </button>
      }

      @if (stepper.selectedIndex === 1) {
        <button
          class="confirm-button"
          matButton="filled"
          data-qa="start-import-button"
          [disabled]="!importReport?.success"
          (click)="upload(false)">
            <mat-icon>cloud_upload</mat-icon>
          Import starten
        </button>
      }

      @if (stepper.selectedIndex === 2) {
        <button
          class="confirm-button"
          matButton="filled"
          data-qa="close-button"
          (click)="close()">
            <mat-icon svgIcon="innogy_picto_close"></mat-icon>
            Schließen
        </button>
      }

    </div>
  </div>
</div>
